// BL-177 Gate 17d — Action Pill Standard: the shared motion numbers for every hover menu.
// v1.01 (Gate 17e, v1.12.040-beta): slower cascade (80ms / 220ms), shorter grace (400ms), 100ms fade-out.
//
// One source of truth for how fast a menu opens, how long it forgives the pointer leaving, and how
// its options cascade in. Both the Communications status-icon menu (CommunicationsThreadFlagControl)
// and every action pill (src/components/ui/ActionPillMenu.jsx) read these, so the two can never
// drift apart. Change a number here and both move together.
// Standard: Docs/Build_Execution/Platform/IntelAgent_Action_Pill_Standard_v1_01.md

// Hover dwell before a menu opens — long enough that a pointer passing over doesn't pop it.
export const MENU_OPEN_DWELL_MS = 250;
// Grace period after the pointer leaves the pill and its menu before the menu closes.
export const MENU_CLOSE_DWELL_MS = 400;
// Closing is quick and all at once: the whole menu fades out over this long, no reverse cascade.
// (A menu closed because another one opened skips even this — it goes instantly.)
export const MENU_CLOSE_FADE_MS = 100;
// Options cascade in one after another, this far apart, nearest the parent pill first.
export const MENU_ITEM_STAGGER_MS = 80;
// Each option fades in and rises this far (translate-y-1) over this long.
export const MENU_ITEM_RISE_MS = 220;
export const MENU_ITEM_RISE_PX = 4;
export const MENU_ITEM_RISE_EASING = 'ease-out';
// Touch: holding a pill this long opens its menu instead of firing its click.
export const LONG_PRESS_MS = 500;

/**
 * Cascade delay for the option at `index` of `count`. `nearestIsLast` is true when the menu opens
 * above its pill, so the bottom option (the last one) sits nearest the pill and goes first.
 */
export function cascadeDelayMs(index, count, { nearestIsLast = false } = {}) {
    const safeCount = Math.max(0, Number(count) || 0);
    const safeIndex = Math.min(Math.max(0, Number(index) || 0), Math.max(0, safeCount - 1));
    const step = nearestIsLast ? safeCount - 1 - safeIndex : safeIndex;
    return step * MENU_ITEM_STAGGER_MS;
}
